import { SxProps } from "@mui/material";

export const sxButtonReagendar: SxProps = {
	borderRadius: '80px',
	height: '44px',
	textWrap: 'nowrap',
	padding: '24px 32px 24px 32px',
	gap: '16px',
	marginRight: '20px',
	'@media (max-width: 720px)': {
		width: 'stretch',
		marginBottom: '15px',
	}
}

export const sxBold: SxProps = {
	fontFamily: 'UnimedSans-Bold',
	fontSize: '16px',
	lineHeight: '24px',
	color: '#383838'
}

export const sxSemibold: SxProps = {
	fontFamily: 'Unimed-Sans',
	fontWeight: 600,
	fontSize: '16px',
	lineHeight: '24px',
	color: '#4C4C4C'
}

export const sxItalic: SxProps = {
	fontFamily: 'Unimed-Sans',
	fontWeight: 400,
	fontSize: '16px',
	lineHeight: '24px',
	color: '#717171',
	fontStyle: "italic"
}

export const sxRegular: SxProps = {
	fontFamily: 'Unimed-Sans',
	fontSize: '16px',
	lineHeight: '24px',
	color: '#4C4C4C'
}

export const sxRegularLight: SxProps = {
	fontFamily: 'Unimed-Sans',
	fontSize: '16px',
	lineHeight: '24px',
	color: '#717171'
}

export const sxSubtitle: SxProps = {
	color: '#4C4C4C',
	fontFamily: 'Unimed-Sans',
	fontSize: '16px',
	fontStyle: 'normal',
	fontWeight: '400',
	lineHeight: '24px',
	marginBottom: '25px',
	maxWidth: '700px'
}

export const sxAdvertise: SxProps = {
	color: '#4C4C4C',
	fontFamily: 'Unimed-Sans',
	fontSize: '18px',
	fontStyle: 'normal',
	fontWeight: '400',
	lineHeight: '24px',
	marginBottom: '25px',
	maxWidth: '700px'
}

export const sxModalTitle: SxProps = {
	fontFamily: 'UnimedSans-Bold',
	fontSize: '18px',
	lineHeight: '24px',
	color: '#383838'
}

export const sxModalSubtitle: SxProps = {
	fontFamily: 'Unimed-Sans',
	fontWeight: 600,
	fontSize: '16px',
	lineHeight: '24px',
	color: '#717171',
}

export const sxTextField: SxProps = {
	width: '100%',
	input: {
		fontFamily: 'Unimed-Sans',
		color: '#383838',
		fontSize: '14px',
	},
	'@media (max-width: 1130px)': {
		width: '100%'
	}
}

export const sxButton: SxProps = {
	fontFamily: 'Unimed-Sans',
	borderRadius: '80px',
	padding: '12px 32px ',
}

export const sxModal: SxProps = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	maxWidth: '700px',
	width: '85%',
	bgcolor: '#fff',
	borderRadius: '16px',
	border: 'none',
	boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
	padding: '32px',
	gap: '24px',
	maxHeight: '100vh',
	overflow: 'auto',
}

export const sxPagination: SxProps = {
	width: 'auto',
	height: '32px',
	background: 'unset',
	color: 'unset',
	fontSize: 'unset',
	fontStyle: 'unset',
	fontWeight: 'unset',
	lineHeight: 'unset',
	position: 'unset',
	button: {
		fontFamily: 'UnimedSans-Bold',
		backgroundColor: '#EEE',
		color: '#5F5F5F'
	}
}

export const sxError: SxProps = {
	color: '#D84141',
	fontSize: '12px'
}

export const sxCalendar: SxProps = {
    width: '100%',
    ".MuiDateCalendar-root": {
        backgroundColor: '#00995D',
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08);'
    },
    ".MuiPickersCalendarHeader-root": {
        backgroundColor: '#00995D',
        color: '#fff',
        textTransform: 'uppercase',
        borderRadius: '10px 10px 0px 0px',
        paddingTop: '15px',
        paddingBottom: '15px',
        margin: '0',
        maxHeight: 'none',
    },
    ".MuiPickersCalendarHeader-labelContainer": {
        fontFamily: 'Unimed-Sans',
        fontWeight: '700',

    },
    ".MuiDayCalendar-root": {
        backgroundColor: "#fff"
    },
    ".MuiPickersCalendarHeader-switchViewButton": {
        color: '#fff'
    },
    ".MuiPickersArrowSwitcher-button": {
        color: '#fff'
    },
    ".MuiDayCalendar-weekDayLabel": {
        fontFamily: 'Unimed-Sans',
        fontWeight: '700',
        color: '#4C4C4C'
    },
    ".MuiPickersDay-root": {
        fontFamily: 'Unimed-Sans',
    },
    "MuiPickersDay-root:focus": {
        backgroundColor: '#00995D'
    },
    "& .MuiPickersDay-root:focus-visible": {
      outline: "2px solid black", 
    },
    "MuiPickersDay-root:hover": {
        backgroundColor: '#00995D'
    },
    ".MuiPickersYear-yearButton": {
        fontFamily: 'Unimed-Sans',
        color: '#4C4C4C'
    },
    ".Mui-selected": {
        backgroundColor: '#00995D',
        color: "#fff"
    },
    ".Mui-selected:focus": {
        backgroundColor: '#00995D'
    },
    ".Mui-selected:hover": {
        backgroundColor: '#156D44'
    },
    ".Mui-disabled": {
        background: 'none'
    },
    '.MuiButton:hover .MuiButton-contained': {
        backgroundColor: '#00995D',
    },
	".MuiPickersDay-root.Mui-selected": {
        backgroundColor: '#00995D',
    },
}

export const sxLabel: SxProps = {
	fontFamily: 'Unimed-Sans',
	color: '#383838',
	fontWeight: 600,
	marginBottom: '8px'
}